/* global ajax_object */
// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/rollnumber';
import './plugins/pagination'; // eslint-disable-line
import './plugins/modernizr.min';
import Swiper, { Autoplay, FreeMode, Navigation } from 'swiper';
import { CountUp } from 'countup.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import ScrollOut from 'scroll-out';

Swiper.use([Autoplay, FreeMode, Navigation]);

import 'jquery-match-height';
import objectFitImages from 'object-fit-images';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Change img src for mobile / desktop
 */
function imgBgSrc() {
  let $imgs = $('.js-img-bg');

  $imgs.each(function () {
    let $src_d = $(this).attr('data-src-d');
    let $src_m = $(this).attr('data-src-m');

    if ($(window).width() < 768 && $src_m.length) {
      $(this).attr('src', $src_m);
    } else {
      $(this).attr('src', $src_d);
    }
  });
}

/**
 * Brands slider
 */
function brandsSlider($slider, $direction, $slides) {
  if ($slides >= 5) {
    $slides = 5;
  } else if ($slides <= 4) {
    $slides = 4;
  }

  let mSlides = false,
    mSlidesLg = false,
    mSlidesMd = false;

  if ($slider.hasClass('js-txt-logo')) {
    mSlides = 1;
    mSlidesMd = 1.5;
    mSlidesLg = 2.5;
  }

  let swiper = new Swiper($slider[0], {
    speed: 6000,
    spaceBetween: 0,
    autoplay: {
      delay: 0,
      reverseDirection: $direction,
    },
    loop: true,
    allowTouchMove: false,
    disableOnInteraction: true,
    breakpoints: {
      320: {
        slidesPerView: mSlides ? mSlides : 1,
      },
      375: {
        slidesPerView: mSlides ? mSlides : 1.25,
      },
      575: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: mSlidesMd ? mSlidesMd : 3,
      },
      1025: {
        slidesPerView: mSlidesLg ? mSlidesLg : $slides,
      },
      1440: {
        slidesPerView: 3,
      },
      1920: {
        slidesPerView: $slides,
      },
    },
  });
  swiper.init();
}

/**
 * teaser slider
 */
function teaserSlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 4000,
    spaceBetween: 0,
    autoplay: {
      delay: 0,
    },
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    allowTouchMove: false,
    disableOnInteraction: true,
    /*breakpoints: {
          320: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 1.75,
          },
          1025: {
            slidesPerView: 2.5,
          },
          1440: {
            slidesPerView: 'auto',
          },
        },*/
  });
  swiper.init();
}

/**
 * Images Catpion Slider
 */
function imagesCaptionSlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 500,
    spaceBetween: 40,
    navigation: {
      nextEl: '.js-swiper-btn-next',
      prevEl: '.js-swiper-btn-prev',
    },

    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 1.25,
      },
      768: {
        slidesPerView: 1.4,
        spaceBetween: 40,
      },
      1025: {
        slidesPerView: 1.4,
      },
      1440: {
        slidesPerView: 1.5,
      },
    },
  });

  swiper.init();
}

/**
 * News Slider
 */
function newsSlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 500,
    spaceBetween: 40,
    navigation: {
      nextEl: '.js-news-next',
      prevEl: '.js-news-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.16,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 1.25,
      },
      768: {
        slidesPerView: 1.4,
        spaceBetween: 40,
      },
      1025: {
        slidesPerView: 1.4,
      },
      1440: {
        slidesPerView: 1.5,
      },
    },
  });

  swiper.init();
}

/**
 * Family Slider
 */
function familySlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 500,
    spaceBetween: 60,
    slidesPerView: 1.8,
    navigation: {
      nextEl: '.js-family-btn-next',
      prevEl: '.js-family-btn-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.16,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 1.25,
      },
      768: {
        slidesPerView: 1.4,
        spaceBetween: 40,
      },
      1025: {
        slidesPerView: 1.4,
      },
      1441: {
        slidesPerView: 1.75,
      },
    },
  });

  swiper.init();
}

/**
 * Team slider
 */
function teamSlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.js-swiper-btn-next',
      prevEl: '.js-swiper-btn-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.65,
        spaceBetween: 40,
      },
      575: {
        slidesPerView: 2.65,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 2.65,
        spaceBetween: 40,
      },
      1025: {
        slidesPerView: 3.65,
        spaceBetween: 60,
      },
      1440: {
        slidesPerView: 4.8,
        spaceBetween: 100,
      },
    },
  });

  swiper.init();
}

/**
 * Modal Slider
 */
function modalSlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 500,
    slidesPerView: 1,
    navigation: {
      nextEl: '.js-btn-next',
      prevEl: '.js-btn-prev',
    },
  });

  swiper.init();
}

/**
 * Fixed Header
 */
function stickyHeader() {
  let $header = $('.header'),
    scroll = $(window).scrollTop();
  let HeaderHeight = $header.outerHeight(true);
  document.documentElement.style.setProperty(
    '--HeaderHeight',
    `${HeaderHeight}px`
  );

  if (scroll >= 0) $header.addClass('is-sticky');
  else $header.removeClass('is-sticky');
  document.documentElement.style.setProperty(
    '--HeaderHeight',
    `${HeaderHeight}px`
  );
}

/**
 * Copy to clipboard
 */
// function copyToClipboard(value) {
//   navigator.clipboard.writeText(value);
// }

/**
 * Hide / Show Collections filters
 */
function hideShowCollectionsFilters() {
  $('.js-collections-filters').on('click', function () {
    $('.collections-filters').addClass('is-active');
  });

  $('.js-close-filters').on('click', function () {
    $('.collections-filters').removeClass('is-active');
  });
}

/**
 * Filter collections
 */
function collectionsFilter() {
  let seasons = [],
    c_categories = [];

  $('.js-season  input[type="checkbox"]').each(function () {
    if ($(this).is(':checked')) {
      seasons.push($(this).val());
    }
  });

  $('.js-category  input[type="checkbox"]').each(function () {
    if ($(this).is(':checked')) {
      c_categories.push($(this).val());
    }
  });

  $.ajax({
    url: ajax_object.ajax_url,
    type: 'POST',
    dataType: 'json',
    data: {
      action: 'filter_collections',
      seasons,
      c_categories,
    },
  }).done(function (response) {
    $('.js-collections-grid').html(response.results);
    if ($('.js-teaser-slider').length) {
      $('.js-teaser-slider').each(function () {
        teaserSlider($(this));
      });
    }
  });
}

/**
 * Related collections slider
 */
function relatedCollectionsSlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 500,
    // autoplay: {
    //   delay: 5000,
    // },
    // loop: true,
    spaceBetween: 40,
    slidesPerView: 3.25,
    navigation: {
      nextEl: '.js-rl-btn-next',
      prevEl: '.js-rl-btn-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.25,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 2.25,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.65,
        spaceBetween: 40,
      },
      1025: {
        slidesPerView: 3.25,
      },
    },
  });

  swiper.init();
}

/**
 * Related articles slider
 */

function relatedArticlesSlider($slider) {
  let swiper = new Swiper($slider[0], {
    speed: 500,
    // autoplay: {
    //   delay: 5000,
    // },
    // loop: true,
    // spaceBetween: 40,
    slidesPerView: 2.45,
    navigation: {
      nextEl: '.js-swiper-btn-next',
      prevEl: '.js-swiper-btn-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.25,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 2.25,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 40,
      },
      1025: {
        spaceBetween: 60,
      },
    },
  });

  swiper.init();
}

/**
 *  Hero extended height
 */
function heroExtendedHeight() {
  let $container = $('.hero-extended').find('.hero-extended__content'),
    height = $container.outerHeight() * 2;
  document.documentElement.style.setProperty(
    '--HeroExtendedHeight',
    `${height}px`
  );
}

/**
 * Counters
 */
function countStats() {
  if ($('.text-with-counter').length) {
    $('.text-with-counter').each(function () {
      let $container = $(this);
      if (!$(this).hasClass('counted')) {
        let offset = $(this).offset().top,
          height = $(this).outerHeight(),
          point = offset - height,
          counting = false,
          counter;
        let $counter = $(this).find('.js-counter'),
          value = $counter.attr('data-count'),
          options = {
            startVal: value,
            useEasing: true,
            duration: 161381738,
            useGrouping: true,
            separator: '.',
          };
        counter = new CountUp($counter[0], 100000000, options);

        $(window).on('scroll', function () {
          if ($(window).scrollTop() > point && !counting) {
            counting = true;
            $container.addClass('counted');
            counter.pauseResume();
          }
        });
      }
    });
  }
}

// Vh fix
//CSS height: 100vh; /* Fallback for browsers that do not support Custom Properties */ height: calc(var(--vh, 1vh) * 100);
function vhfix() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

vhfix();

/**
 * Blog post filters
 */
function blogFilters(value, page) {
  $('.js-blog').addClass('loading');
  $.ajax({
    url: ajax_object.ajax_url,
    type: 'POST',
    dataType: 'json',
    data: {
      action: 'blog_filters',
      value: value,
      paged: page,
    },
  }).done(function (response) {
    $('.js-blog').html(response.template);
    $('.js-category-text').html(response.categoryText);

    if (response.total > 1) {
      blogPagination(value, response.total, response.currentPage);
      $('.blog__pagination').removeClass('hide');
    } else if (response.total == 1) {
      $('.blog__pagination').addClass('hide');
    }

    $('html, body').animate(
      { scrollTop: $('.js-blog').offset().top - 200 },
      500
    );

    setTimeout(function () {
      $('.js-blog').removeClass('loading');
    }, 150);
  });
}

/**
 * Pagination
 */
function blogPagination(currentFilter, totalPages, currentPage) {
  $('#js-pagination').pagination({
    // the number of entries
    total: totalPages,
    // current page
    current: currentPage ? currentPage : 1,
    // the number of entires per page
    length: 1,
    // pagination size
    size: 2,
    // Prev/Next text
    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><polygon points="29.49 4.98 24.51 0 6.51 18 24.51 36 29.49 31.02 16.47 18 29.49 4.98"/></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><polygon points="11.49 0 6.51 4.98 19.53 18 6.51 31.02 11.49 36 29.49 18 11.49 0"/></svg>',

    // fired on each click
    click: function (e) {
      blogFilters(currentFilter, e.current);
    },
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Change placeholder for Country dropdown
   */
  if ($('#optimalquantitites').length) {
    $('#optimalquantitites option:first')[0].innerHTML = 'Optimal Quantities';
  }

  /**
   * Detect element appearance in viewport
   */
  ScrollOut();

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  $('.menu-icon').on('click', function () {
    $(this).toggleClass('is-active');
    $('.header').toggleClass('menu-open');
    $('#main-menu').toggleClass('is-active');
  });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  /**
   * Rollnumber counter
   */

  if ($('.js-rollnumber').length) {
    $('.js-rollnumber').each(function () {
      let number = $(this).attr('data-count');
      $(this).rollNumber({
        number: number,
        // speed: 750,
        // interval: 50,
        space: 100,
        symbol: '.',
        fontStyle: {
          'font-size': 'inherit',
          'font-family': 'inherit',
          color: 'inherit',
        },
      });
    });
  }

  /**
   * hero-extended height
   */
  if ($('.hero-extended').length) {
    heroExtendedHeight();
  }

  // Init resizeVideo
  resizeVideo();

  // Init imgBgSrc
  imgBgSrc();

  // Init Brands Slider
  if ($('.js-brands-slider-top').length) {
    $('.js-brands-slider-top').each(function () {
      brandsSlider($(this), $(this).attr('reverse'), $(this).attr('slides'));
    });
  }
  if ($('.js-brands-slider-bot').length) {
    $('.js-brands-slider-bot').each(function () {
      brandsSlider($(this), $(this).attr('reverse'), $(this).attr('slides'));
    });
  }

  /**
   * Close modal
   */
  $('.js-close-modal').on('click', function () {
    $(this).closest('.modal').addClass('hidden');
  });

  $('a[href*="#modal"]').each(function () {
    $(this).on('click', function () {
      $('.modal').removeClass('hidden');
    });
  });

  // Init stickyHeader
  stickyHeader();

  // Init Images Caption Slider
  if ($('.js-img-caption-slider').length) {
    $('.js-img-caption-slider').each(function () {
      imagesCaptionSlider($(this));
    });
  }

  // Init team slider
  if ($('.js-team-slider').length) {
    $('.js-team-slider').each(function () {
      teamSlider($(this));
    });
  }

  // Init Modal slider
  if ($('.js-modal-slider').length) {
    $('.js-modal-slider').each(function () {
      modalSlider($(this));
    });
  }

  // Init News slider
  if ($('.js-news-slider').length) {
    $('.js-news-slider').each(function () {
      newsSlider($(this));
    });
  }

  if ($('.js-family-slider').length) {
    $('.js-family-slider').each(function () {
      familySlider($(this));
    });
  }

  /*$('.js-copy-to-cb').on('click', function () {
      copyToClipboard($(this).val());
    });*/

  if ($('.js-teaser-slider').length) {
    $('.js-teaser-slider').each(function () {
      teaserSlider($(this));
    });
  }

  $('.js-close-subheading').on('click', function () {
    $(this).closest('.single-hero__subheading').slideUp();
  });

  // Init hide / show filters
  hideShowCollectionsFilters();

  // Filter collections
  $('.js-filter-collections').on('click', function () {
    collectionsFilter();
  });

  if ($('.js-single-hero-slider').length) {
    $('.js-single-hero-slider').each(function () {
      modalSlider($(this));
    });
  }

  if ($('.js-rl-slider').length) {
    $('.js-rl-slider').each(function () {
      relatedCollectionsSlider($(this));
    });
  }

  countStats();

  //  Filter blog posts
  $('.js-filters').on('click', '.button', function () {
    window.history.replaceState('', '', window.location.href.split('?')[0]);
    $('.js-filters .button').removeClass('active');
    $(this).addClass('active');
    blogFilters($(this).val(), 1);
  });

  // Init Pagination
  let currentFilter = $('.js-filters').find('.button.active').val();
  let totalPages = parseInt($('#js-pagination').attr('data-max-pages'));
  blogPagination(currentFilter, totalPages);

  //  Related arcticles
  if ($('.js-related-articles').length) {
    $('.js-related-articles').each(function () {
      relatedArticlesSlider($(this));
    });
  }

  $('body').on('click', '.js-show-calendar', function () {
    $('.js-booking-calendar').slideToggle(350);
  });

  $('body').on('click', '#share-url', function (e) {
    e.preventDefault();
    navigator.clipboard.writeText(window.location.href);
  });
});

/**
 * Scripts which run after all element loads
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  const $cf7WithCountry = $('.country-list');
  const $contactForm = $('.js-form-custom');
  if ($cf7WithCountry.length) {
    document
      .querySelector('.wpcf7-countrytext')
      .setAttribute('value', $cf7WithCountry.find('li.active')[0].innerText);
  }
  if ($contactForm.length) {
    $contactForm.closest('form').addClass('is-active');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  // Init resizeVideo
  resizeVideo();

  //Init imgBgSrc
  imgBgSrc();

  heroExtendedHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here

  // Init sticky header
  stickyHeader();

  let $counters = $('.js-counter');
  // $countersWrapper = $('.counters');

  if ($counters.length > 0) {
    // let offset = $countersWrapper.offset().top;
    // let height = $countersWrapper.outerHeight();
    // let statsPoint = offset + height;

    $counters.each(function (i, el) {
      if (!$(el).hasClass('counted')) {
        let offset = $(el).offset().top;
        let height = $(el).outerHeight();
        let point = offset + height;
        if ($(window).scrollTop() + $(window).outerHeight() >= point) {
          $(el).addClass('counted');
          let $this = $(this),
            countTo = $(el).attr('data-count');
          $({ countNum: $(el).text() }).animate(
            {
              countNum: countTo,
            },
            {
              duration: 2500,
              easing: 'linear',
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
              },
            }
          );
        }
      }
    });
  }
});
